"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchRestaurantsResponseAllOfToJSON = exports.SearchRestaurantsResponseAllOfFromJSONTyped = exports.SearchRestaurantsResponseAllOfFromJSON = void 0;
var _1 = require("./");
function SearchRestaurantsResponseAllOfFromJSON(json) {
    return SearchRestaurantsResponseAllOfFromJSONTyped(json, false);
}
exports.SearchRestaurantsResponseAllOfFromJSON = SearchRestaurantsResponseAllOfFromJSON;
function SearchRestaurantsResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'restaurants': (json['restaurants'].map(_1.RestaurantSearchResultFromJSON)),
    };
}
exports.SearchRestaurantsResponseAllOfFromJSONTyped = SearchRestaurantsResponseAllOfFromJSONTyped;
function SearchRestaurantsResponseAllOfToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'restaurants': (value.restaurants.map(_1.RestaurantSearchResultToJSON)),
    };
}
exports.SearchRestaurantsResponseAllOfToJSON = SearchRestaurantsResponseAllOfToJSON;
